import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    let alive = true;
    if (!localStorage.getItem("ph_token")) { setUser(false); return undefined; }
    http.get("/auth/me")
      .then(({ data }) => { if (alive) setUser(data); })
      .catch(() => { if (alive) setUser(false); });
    return () => { alive = false; };
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    localStorage.setItem("ph_token", data.token);
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try { await http.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("ph_token");
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
